import { createDraftSafeSelector } from '@reduxjs/toolkit';

import type { RootState } from '@polyai/stream/store';
import { handoffSelectors } from '@polyai/stream/store/reducers/handoff';

export const selectHandoff = (state: RootState) => state.handoff;

export const selectHandoffByIds = createDraftSafeSelector(
  [selectHandoff, (_state: RootState, ids: string[]) => ids],
  ({ handoffs }, ids) => {
    return ids.map(id => {
      return handoffSelectors.selectById(handoffs, id);
    });
  },
);

export const selectActiveHandoffs = createDraftSafeSelector(
  [selectHandoff],
  ({ handoffs }) => {
    return handoffSelectors
      .selectAll(handoffs)
      .filter(handoff => handoff && handoff.active);
  },
);

export const selectHandoffs = createDraftSafeSelector(
  [selectHandoff],
  ({ handoffs }) => {
    return handoffSelectors.selectAll(handoffs).filter(e => e.active);
  },
);
